// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 502) return "static/js/502.7b533f0f6.chunk.js";
	if (chunkId === 777) return "static/js/recorder.7b533f0f6.chunk.js";
	if (chunkId === 12) return "static/js/profiler.7b533f0f6.chunk.js";
	if (chunkId === 331) return "static/js/331.7b533f0f6.chunk.js";
	if (chunkId === 38) return "static/js/38.7b533f0f6.chunk.js";
	if (chunkId === 506) return "static/js/506.7b533f0f6.chunk.js";
	if (chunkId === 420) return "static/js/420.7b533f0f6.chunk.js";
	if (chunkId === 854) return "static/js/854.7b533f0f6.chunk.js";
	if (chunkId === 725) return "static/js/725.7b533f0f6.chunk.js";
	if (chunkId === 946) return "static/js/946.7b533f0f6.chunk.js";
	if (chunkId === 916) return "static/js/916.7b533f0f6.chunk.js";
	// return url for filenames based on template
	return undefined;
};